import { Component, Input, ElementRef, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { BsDropdownDirective, BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { CommonModule } from '@angular/common';
import { Application } from '../../enums/application.enums';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { Subject, Subscription } from 'rxjs';

// Shared subject to coordinate closing dropdowns
const closeAllDropdowns$ = new Subject<BsDropdownDirective>();

@Component({
  selector: 'app-info-icon',
  templateUrl: './info-icon.component.html',
  styleUrls: ['./info-icon.component.scss'],
  imports: [CommonModule, BsDropdownModule],
  standalone: true
})
export class InfoIconComponent implements OnInit, OnDestroy {
  @ViewChild(BsDropdownDirective) dropdown: BsDropdownDirective;
  @Input() message: string = '';
  @Input() cls: string = '';
  @Input() height: number = Application.SIXTEEN;
  @Input() width: number = Application.SIXTEEN;
  @Input() iconName: string = null;
  @Input() iconInfoClass: string = '';

  private subscription: Subscription;

  constructor(
    private el: ElementRef,
    private cs: CommonService
  ) {}

  ngOnInit(): void {
    this.subscription = closeAllDropdowns$.subscribe((openedDropdown) => {
      if (this.dropdown && this.dropdown !== openedDropdown && this.dropdown.isOpen) {
        this.dropdown.hide();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onDropdownShown(): void {
    closeAllDropdowns$.next(this.dropdown);
  }
  get isSpaceAvailableOnLeft() {
    if (this.cs.isBrowser) {
      const button = this.el.nativeElement.querySelector(
        '.info-icon-toggle'
      ) as HTMLElement | null;
      if (!button) {
        return '';
      }
      const buttonRect = button.getBoundingClientRect();
      const spaceOnLeft = buttonRect.left - Application.TWELVE;
      const spaceOnRight =
        window.innerWidth - buttonRect.left - Application.TWELVE;

      if (
        spaceOnLeft < Application.TWO_HUNDRED_EIGHTY &&
        spaceOnRight >= spaceOnLeft
      ) {
        return 'left-0';
      }
    }
    return '';
  }
  get formattedMessage(): string {
    return this.message.replace(/\n/g, '<br>');
  }
}
